module.exports = __webpack_public_path__ + "static/assets/77d3dbbe1fe1d4a251f68a2be0f8f5cb.png";